import { app } from '../../../bootstrap/core';
import { boxComponent } from './box.component';

app.component('box', boxComponent);
